document.addEventListener('DOMContentLoaded', function () {
  console.log("🚀 timeline.js is running!");

  const timelineItems = document.querySelectorAll('.timeline-item');

  if (!timelineItems) {
    console.error("❌ Timeline items missing!");
    return;
  }

  function updateTimeline() {
    timelineItems.forEach((item) => {
      const itemRect = item.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (itemRect.top < windowHeight * 0.8 && itemRect.bottom > windowHeight * 0.2) {
        item.classList.add('visible');
      } else {
        item.classList.remove('visible');
      }
    });
  }

  window.addEventListener('scroll', updateTimeline);
  window.addEventListener('resize', updateTimeline);
  updateTimeline();
});
